import React from 'react';
import { ExpandOutlined } from '@ant-design/icons';
import { CardSelector } from '../shared/card-selector';
import { useEditorContext } from '../../context/editor-context';
import { getPlanos, getPlanoPreview, resolutionToAspectRatio } from '../../utils/avatar-lookups';
import { capitalize } from '../../../../utils/capitalze';

/**
 * Plano section — tercer nivel del selector encadenado.
 * Muestra medio / pecho / entero con preview de la combinación exacta.
 * Solo se renderiza si hay vestuario y ambiente elegidos.
 */
export const PlanoSection: React.FC = () => {
  const { scene, activeIndex, updateScene, selectedResolution } = useEditorContext();
  const resolucion = resolutionToAspectRatio(selectedResolution);

  if (!scene.vestuario || !scene.ambiente) return null;

  const planos = getPlanos(scene.vestuario, scene.ambiente, resolucion);

  const options = planos.map(p => ({
    id: p,
    label: capitalize(p),
    imageUrl: getPlanoPreview(scene.vestuario, scene.ambiente, resolucion, p)
  }));

  return (
    <CardSelector
      label='Plano'
      icon={<ExpandOutlined />}
      options={options}
      value={scene.plano}
      onChange={id => updateScene(activeIndex, 'plano', id)}
    />
  );
};
